import { render, staticRenderFns } from "./PasswordLostPage.vue?vue&type=template&id=173e02b8&scoped=true&"
import script from "./PasswordLostPage.vue?vue&type=script&lang=ts&"
export * from "./PasswordLostPage.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordLostPage.vue?vue&type=style&index=0&id=173e02b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e02b8",
  null
  
)

export default component.exports